export default "__VITE_ASSET__CWQIHR84__"